import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import TestimonialSection from './../../components/HomePage/TestimonialSection';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditTestimonialtextThree = () => {


    const [testimonialTextThree, settestimonialTextThree] = useState([]);

    const { id } = useParams();


    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/testimonialtext-three/${id}`)
            .then((res) => res.json())
            .then((info) => settestimonialTextThree(info));
    }, []);



    const handleTestimonialSection = (event) => {
        event.preventDefault();
        const testimonialTextThree = event.target.testimonialTextThree.value;
        const testimonialHeadingThree = event.target.testimonialHeadingThree.value;
     

        const testimonialSection = {
            testimonialTextThree,
            testimonialHeadingThree,
            
        };

        const url = `https://aprilone-178ea8362c0b.herokuapp.com/testimonialtext-three/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(testimonialSection),
        })
            .then((res) => res.json())
            .then((result) => {

                alert(' Testimonial Text Is Updated');
            });
    };








    return (
        <> 
        <HeaderBottom></HeaderBottom>
        <section id="services" class="services-area vh-100">
        <div className='mt-5'>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8 col-md-12">

                        

                        <form class="contact-form " onSubmit={handleTestimonialSection}>
                        <h3 className='mb-5 text-center'> Update Testimonial Text </h3>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="contact-field p-relative c-name mb-20">
                                        <input  className="form-control mb-3" name="testimonialTextThree" defaultValue={testimonialTextThree.testimonialTextThree} placeholder="Testimonial Text" required />
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <div class="contact-field p-relative c-name mb-20">
                                        <input className="form-control mb-3" name="testimonialHeadingThree" defaultValue={testimonialTextThree.testimonialHeadingThree} placeholder="Testimonial Heading" required />
                                    </div>
                                </div>
                                <div class="slider-btn text-center">
                                    <button class="button-professional" data-animation="fadeInRight" data-delay=".8s"> Update Testimonial Text </button>
                                </div>
                            </div>

                        </form>



                    </div>


                </div>
            </div>





        </div>
    </section></>
       
    );
};

export default EditTestimonialtextThree;